// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2cvx_","detailsBorder":"styles_detailsBorder__2Ey5B"};